import type { AccountMismatch } from './sales-force-account-reconciliation';
import { accountCanSync, accountClearedFields, accountFieldName, accountSyncBlockedTooltip,
  accountValue } from './account-reconciliation-presentation';
import { useReconciliationSyncControls } from './reconciliation-sync-controls';

export function useAccountSyncControls(onRefresh?: () => void) {
  return useReconciliationSyncControls<AccountMismatch>({
    entity: 'accounts', namespace: 'salesForceAccountReconciliation',
    rowKey: (row) => `${row.salesforceId}:${row.webkuaId}`,
    identityField: 'companyNumber', identity: (row) => row.companyNumber,
    target: (row) => ({ salesforceId: row.salesforceId, webkuaId: row.webkuaId, companyNumber: row.companyNumber }),
    visible: (row) => row.kind === 'FieldMismatch',
    blockReason: (row) => accountCanSync(row) ? null : 'AmbiguousLink',
    blockedTooltip: accountSyncBlockedTooltip, differences: (row) => row.differences,
    usesClears: true, clearedFields: accountClearedFields,
    rowWarning: (row, text) => row.billingCityMatchingPlace
      ? text('sync.billingCityWarning', { city: row.billingCityMatchingPlace }) : null,
    previewWarning: (preview, text) => preview.billingCityMatchingPlace
      ? text('sync.billingCityWarning', { city: preview.billingCityMatchingPlace }) : null,
    fieldName: accountFieldName, value: (_, value, text) => accountValue(value, text),
    valueColumns: ['salesforceValue', 'webkuaValue'],
  }, onRefresh);
}
